import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useFormContainerContext } from '../../Services/FormContainerContext';
// @ts-ignore
import styles from './FormCondition.module.scss';
import useFormCondition from './hooks/useFormCondition';
import useFormName from '../../Hooks/useFormName';

interface FormConditionProps {
	controlName: string;
	equal?: string | boolean;
	in?: string[] | number[];
	children?: any;
	rules?: FormConditionRule[];
}

export interface FormConditionRule {
	formControlKey: string;
	rule: 'equal' | 'in' | 'notEqual' | 'startsWith' | 'notStartsWith' | 'filled';
	value: any;
}

const FormCondition = (props: FormConditionProps) => {
	const { controlName, children, equal, in: pin, rules } = props;

	const { fieldName } = useFormName({ name: controlName });

	const { result } = useFormCondition({
		rules,
	});

	const { watch } = useFormContext();

	if (!result) {
		return null;
	}

	const value = watch(fieldName);
	const rValue = value?.value?.code || value?.value || value;

	if (typeof equal !== 'undefined') {
		if (rValue !== equal) {
			return null;
		}
	}

	if (typeof pin !== 'undefined') {
		// @ts-ignore
		if (pin.indexOf(rValue) === -1) {
			return null;
		}
	}

	return <div>{children}</div>;
};

export default FormCondition;
